(function () {
  'use strict';

  function initBanner(root) {
    if (!root || root.dataset.pmBannerBound === '1') return;
    root.dataset.pmBannerBound = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.pm-banner__slide'));
    if (!slides.length) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.pm-banner__dot'));
    var autoplay = root.dataset.autoplay === 'true' || root.dataset.autoplay === '1';
    var interval = parseInt(root.dataset.interval || '5000', 10);
    if (!(interval > 0)) interval = 5000;

    var index = 0;
    var timer = null;

    function setActive(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function start() {
      if (!autoplay || slides.length < 2) return;
      clearInterval(timer);
      timer = setInterval(function () {
        setActive(index + 1);
      }, interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var target = parseInt(dot.getAttribute('data-pm-banner-dot') || '0', 10) || 0;
        setActive(target);
        start();
      });
    });

    root.addEventListener('mouseenter', stop, { passive: true });
    root.addEventListener('mouseleave', start, { passive: true });

    setActive(0);
    start();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pm-banner-root]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) boot(event.target);
  });
})();
